/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react';

const HomePage = () => (
  <h1>Welcome to Dayaxe!</h1>
);

export default HomePage;
